/* istanbul ignore file */
import { Environment } from './contentstackEnvironment';
import type { StackConfig } from './types';

/*
  Contentstack apiKeys and access tokens are for read-only access
  to published (publicly available) content only.
 */
export const stackConfig: StackConfig = {
  // TODO: There should not be knowledge of API keys and delivery tokens in this package, except maybe for global nav
  DX: {
    apiKey: 'blt63f2f7afd19b09c2',
    envs: {
      [Environment.Preview]: {
        name: 'preview',
        token: 'cs6b024ec1b1264584a5e0d80d',
      },
      [Environment.Qa]: {
        // No QA environment for DX, so use Production name and token
        name: 'production',
        token: 'csf98668b74309f76a6578a171',
      },
      [Environment.Production]: {
        name: 'production',
        token: 'csf98668b74309f76a6578a171',
      },
    },
  },
  GlobalComponents: {
    apiKey: 'blt6444b9076ec27f02',
    envs: {
      [Environment.Preview]: {
        name: 'preview',
        token: 'cs32921c345201a090417b8a63',
      },
      [Environment.Qa]: {
        name: 'qa',
        token: 'cs61a1b6b4cd96389fcad2440e',
      },
      [Environment.Production]: {
        name: 'live',
        token: 'cs1a9f7493ebc95bee270e3755',
      },
    },
  },
};
